import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import ChartUserByCountry from './ChartUserByCountry';
import CustomizedTreeView from './CustomizedTreeView';
import CustomizedDataGrid from './CustomizedDataGrid';
import HighlightedCard from './HighlightedCard';
import PageViewsBarChart from './PageViewsBarChart';
import SessionsChart from './SessionsChart';
import StatCard from './StatCard';
import ActorStatCard from './ActorStatCard';
import axios from "axios";
import {useEffect, useState,useContext} from "react";
import ActorAnalyticsCard from "./ActorAnalyticsStatCard"
import {styled} from "@mui/material/styles";
import MediaQuery from "react-responsive";
import CombinedGraph from "./CombinedGraph"
import CustomDatePicker from './CustomDatePicker';
import dayjs from "dayjs";
import { AuthContext } from "./signin/AuthContext";


const data_actors = [
  {
    title: 'Users',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [ 200, ],
    measure: 'Licht',
    dict_val: 'licht',
    is_actor: false,
  },
  {
    title: 'Conversions',
    value: '325',
    interval: 'Last day',
    trend: 'warning',
    data: [ 200, ],
    measure: 'Abluft',
    dict_val: 'abluft',
    text: '{measure}',
    is_actor: false,
  },
  {
    title: 'Users',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [ 200, ],
    measure: 'Umluft',
    dict_val: 'umluft',
    is_actor: false,
  },
  {
    title: 'Conversions',
    value: '325',
    interval: 'Last day',
    trend: 'warning',
    data: [ 200, ],
    measure: 'Heizung',
    dict_val: 'heizung',
    is_actor: false,
  },

];

const data_sensor_block = [
  {
    title: 'Users',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [ 200, ],
    measure: 'Sensor BME',
    dict_val: 'bme',
    is_actor: false,
  },
  {
    title: 'Conversions',
    value: '325',
    interval: 'Last day',
    trend: 'warning',
    data: [ 200, ],
    measure: 'Sensor SHT',
    dict_val: 'sht',
    is_actor: false,
  },
];

const data_controller_block = [
  {
    title: 'Users',
    value: '14k',
    interval: 'Last day',
    trend: 'up',
    data: [ 200, ],
    measure: 'Klimakontroller',
    dict_val: 'klimakontroller',
    is_actor: false,
  },
  {
    title: 'Conversions',
    value: '325',
    interval: 'Last day',
    trend: 'warning',
    data: [ 200, ],
    measure: 'Hydro Kontroller',
    dict_val: 'hydrokontroller',
    is_actor: false,
  },


];
export default function AnalyticsGrid(props) {
    const {token, setToken } = useContext(AuthContext);
    const [gauge_values, setGauge] = useState([]);
    const [grow_setup, setGrowSetup] = useState(props.grow_setup);
    const today = dayjs();
    const yesterday = dayjs().subtract(1, 'day');
    const [value_from, setValueFrom] = React.useState(yesterday);
    const [value_to, setValueTo] = React.useState(today);
    const  fetchData = async () =>{
    var data = []
    var yesterday = new Date();
    yesterday =  new Date(yesterday.setDate(yesterday.getDate() -1));
    var today = new Date();
      try {
        axios.post('/get_current_gauge_values/'+props.grow_setup
            ,{hello:"world"},{
          headers: {'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'Method': 'GET',
          },
        }).then(result => {
              setGauge(result.data);

              //this.state.layout = this.generateLayout(result);
            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });

      } catch (error) {
        console.error(error);
      }
    };

  useEffect(() => {
    setGrowSetup(props.grow_setup);
    fetchData();
    const interval = setInterval(fetchData, 10000);

    return () => clearInterval(interval);
  }, [props.grow_setup]);

  const MyGrid = styled("div")({
    //backgroundColor: `rgba(255, 255, 255, 1)`,
    display: `flex`,
    position: `relative`,
    isolation: `isolate`,
    flexDirection: `row`,
    justifyContent: `flex-start`,
    alignItems: `center`,
    padding: `0px`,
    boxSizing: `border-box`,
    overflow: `hidden`,
    flexWrap: 'wrap'
  });

  const GridBlock = styled("div")({
    //backgroundColor: `rgba(255, 255, 255, 1)`,
    display: `flex`,
    position: `relative`,
    isolation: `isolate`,
    flexDirection: `row`,
    justifyContent: `flex-start`,
    alignItems: `flex-start`,
    padding: `0px`,
    boxSizing: `border-box`,
    width: `500px`,
    height: `hug`,
    margin: `0px`,
    overflow: `hidden`,
    flexWrap: 'wrap'
  });

  const instanceChild = styled("div") ({
    position: 'absolute',
    height: '100%',
    width: '100',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px 1px rgba(0, 0, 0, 0.25) inset',
    borderRadius: '50%',
    background: 'radial-gradient(50% 50% at 50% 50%, #15f800, #1a930f)',
    border: '4px solid #93c387',
    boxSizing: 'border-box',
  });
  const ellipseParent = styled("div") ({
    width: '100%',
    position: 'relative',
    height: '40px'
  });


  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: window.innerWidth *0.8 } }}>
      {/* cards */}

      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <CustomDatePicker label={'Startzeit'} value={yesterday} setValueOuter={setValueFrom} ></CustomDatePicker>
      <CustomDatePicker label={'Endzeit'} value={today} setValueOuter={setValueTo} ></CustomDatePicker>
      <MediaQuery maxWidth={500}>
        <CombinedGraph  height={"480px"} width={"480px"}  grow_setup={props.grow_setup} time_from = {value_from} time_to = {value_to}></CombinedGraph>
        <MyGrid>
          <GridBlock>
        {data_actors.map((card, index) => (

            <ActorAnalyticsCard {...card} gauge_value={gauge_values[card.measure]}  grow_setup={props.grow_setup}  issmall={0} />

        ))}
          </GridBlock>
          <GridBlock>
            {data_sensor_block.map((card, index) => (

                <ActorAnalyticsCard {...card} gauge_value={gauge_values[card.measure]} text={card.text}  grow_setup={props.grow_setup} issmall={0} />

            ))}
          </GridBlock>
          <GridBlock>
            {data_controller_block.map((card, index) => (

                <ActorAnalyticsCard {...card} gauge_value={gauge_values[card.measure]} text={card.text}  grow_setup={props.grow_setup} issmall={0} />

            ))}
          </GridBlock>
        </MyGrid>
      </MediaQuery>
      <MediaQuery maxHeight={500}>
        <CombinedGraph  height={"480px"} width={"480px"}  grow_setup={props.grow_setup} time_from = {value_from} time_to = {value_to}></CombinedGraph>
        <MyGrid>
          <GridBlock>
            {data_actors.map((card, index) => (

                <ActorAnalyticsCard {...card} gauge_value={gauge_values[card.measure]} text={card.text}  grow_setup={props.grow_setup} issmall={0} />

            ))}
          </GridBlock>
          <GridBlock>
            {data_sensor_block.map((card, index) => (

                <ActorAnalyticsCard {...card} gauge_value={gauge_values[card.measure]} text={card.text} grow_setup={props.grow_setup} issmall={0} />

            ))}
          </GridBlock>
          <GridBlock>
            {data_controller_block.map((card, index) => (

                <ActorAnalyticsCard {...card} gauge_value={gauge_values[card.measure]} text={card.text} grow_setup={props.grow_setup} issmall={0} />

            ))}
          </GridBlock>
        </MyGrid>
      </MediaQuery>
      <MediaQuery minWidth={501} minHeight={500}>
        <CombinedGraph    grow_setup={props.grow_setup} time_from = {value_from} time_to = {value_to}></CombinedGraph>


      </MediaQuery>

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
